import NTopNBottom from '../../components/NTopNBottom'
import calcRemFn from '../calcRem'

import bannerImg from '../../assets/aotiShopLabxx/banner.jpg'
import navColor from '../../assets/aotiShopLabxx/nav/color.jpg'

import p1_1 from '../../assets/aotiShopLabxx/ctn/1_1.jpg'
import p1_2 from '../../assets/aotiShopLabxx/ctn/1_2.jpg'
import p1_3 from '../../assets/aotiShopLabxx/ctn/1_3.jpg'
import p1_4 from '../../assets/aotiShopLabxx/ctn/1_4.jpg'
import p2_1 from '../../assets/aotiShopLabxx/ctn/2_1.jpg'
import p2_2 from '../../assets/aotiShopLabxx/ctn/2_2.jpg'
import p3_1 from '../../assets/aotiShopLabxx/ctn/3_1.jpg'
import p3_2 from '../../assets/aotiShopLabxx/ctn/3_2.jpg'
import p3_3 from '../../assets/aotiShopLabxx/ctn/3_3.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'


// 需要手动修改proId
const top1_id = IS_PROD ? '97019' : '97019'
const top2_id = IS_PROD ? '97019' : '97019'
const top3_id = IS_PROD ? '97019' : '97019'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(130.5),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(130.5),
    transition: 'all 0.3s ease'
  },
  topBtnLayout: {
    paddingTop: `${calcRemFn(15)}`,
    marginLeft: `${calcRemFn(239)}`,
    flexWrap: 'wrap',
  },
  topBtnBaseCss: {
    width: calcRemFn(124),
    height: calcRemFn(33),
    opacity: 0
  },
  bottomBtnLayout: {
    display: 'none'
  },
}

const navData = {
  component: NTopNBottom,
  css: ['a','b','c'],
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: false,
        prodId: top1_id
      },
    ],
    top2: [
      {
        key: '_i2',
        show: false,
        prodId: top2_id
      },
    ],
    top3: [
      {
        key: '_i3',
        show: false,
        prodId: top3_id
      },
    ],
  }
}

const pictures = [
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
      p1_2,
      p1_3,
      p1_4,
    ],
    name: '昼夜'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1,
      p2_2,
    ],
    name: '对话'
  },
  {
    id: top3_id,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_1,
      p3_2,
    ],
    name: '候场'
  },
  {
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_3,
    ],
    name: 'tips',
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 20,
  top2_i1: 58,
  top3_i1: 93,
}

export default {
  title: 'Hello-自我介绍',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
